import { MenuItemType } from '../models/menu-item.type';

export const MENU_ITEMS: MenuItemType[] = [];
